import React from 'react';
import styles from './navBar.module.css';
import NavBarItem from './navBarItem/navBarItem';

export default ({ showWhat, setShowWhat }: { showWhat: number; setShowWhat: Function }) => {
  return (
    <>
      <div className={styles.navBar}>
        {['精选', '出版', '原创', '分类'].map((item, index) => {
          return <NavBarItem {...{ item: item, index: index, showWhat: showWhat, setShowWhat: setShowWhat }} key={index}></NavBarItem>;
        })}
      </div>
    </>
  );
};
